import _ from 'lodash';
import { useEffect, useState } from 'react';

import { getScheduleItems, triggerSchedule } from '../../repositories/HttpRepository';
export default function useSchedule() {
  const [originSchedules, setOriginSchedules] = useState([]);
  const [schedules, setSchedules] = useState([]);
  const [types, setTypes] = useState([]);
  const [scheduleMap, setScheduleMap] = useState({});

  const [type, setType] = useState();
  const [keyword, setKeyword] = useState();

  useEffect(() => {
    getScheduleItems().then((resp) => {
      if (resp.ok) {
        setOriginSchedules(resp.data);
      }
    });
  }, []);

  useEffect(() => {
    // calculate types
    if (schedules !== undefined) {
      const types = _.uniq(schedules.map((s) => s.type));
      types.sort();
      setTypes(types);
      const sortByType = (s) => _.get(types, s.type, 0);

      setScheduleMap(_.groupBy(schedules, 'type'));
    }
  }, [schedules, keyword]);

  useEffect(() => {
    // calculate types
    if (originSchedules !== undefined) {
      const filteredItems = originSchedules.filter((s) => {
        if (!s.active) {
          return false;
        }

        if (keyword !== undefined && !_.isEmpty(keyword)) {
          if (!s.name && !s.type) return false;

          if (!s.name) s.name = '';
          if (!s.type) s.type = '';

          const kw = keyword.toLowerCase();
          return s.name.toLowerCase().includes(kw) || s.type.toLowerCase().includes(kw);
        }

        return true;
      });

      setSchedules(filteredItems);
    }
  }, [originSchedules, keyword]);

  const trigger = (id, item, fireTime) => {
    return triggerSchedule(id, item, fireTime);
  };

  return {
    schedules,
    originSchedules,
    keyword,
    setKeyword,
    types,
    scheduleMap,
    type,
    setType,
    trigger,
  };
}
